"use client";

import React from "react";
import { ArrowUpRight, Compass } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Consultation() {
  const shouldReduceMotion = useReducedMotion();
  const initialMotion = shouldReduceMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 16
  };
  const animateMotion = {
    opacity: 1,
    y: 0
  };
  return <section id="call-to-action" data-nav="light" className="relative w-full border-y border-border bg-background py-20 text-foreground md:py-28">
      {/* Subtle decorative Orbit Ring motif */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden opacity-30">
        <div className="size-[540px] rounded-full border border-border md:size-[680px]" />
        <div className="absolute size-[360px] rounded-full border border-border/60 md:size-[460px]" />
      </div>

      <div className="container relative mx-auto max-w-4xl px-6 text-center">
        <motion.div initial={initialMotion} whileInView={animateMotion} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center">
          {/* Eyebrow Label */}
          <div className="mb-4 inline-flex items-center gap-2 text-xs font-semibold tracking-[0.18em] uppercase text-muted-foreground">
            <Compass className="size-3.5 stroke-[1.25] text-primary" />
            <span>Anchor &amp; Orbit™ Travel Design</span>
          </div>

          {/* Heading */}
          <h2 className="font-serif text-3xl font-medium tracking-tight text-foreground sm:text-4xl md:text-5xl">
            Begin your family&apos;s next milestone
          </h2>

          {/* Sterling Editorial Rule with Centered Diamond Accent */}
          <div className="my-6 flex w-24 items-center justify-center">
            <div className="h-px w-full bg-border" />
            <div className="size-1.5 shrink-0 rotate-45 border border-border bg-background" />
            <div className="h-px w-full bg-border" />
          </div>

          {/* Supporting Copy */}
          <p className="mx-auto mb-10 max-w-2xl font-sans text-base leading-relaxed text-foreground/85 md:text-lg">
            Every multi-generational journey starts with a private conversation.
            We align individual rhythms, resolve logistical friction, and design
            unhurried milestones for the people who matter most.
          </p>

          {/* Action CTA */}
          <div className="flex flex-col items-center gap-4 sm:flex-row">
            <Button asChild className="h-auto rounded-xs bg-primary px-8 py-4 font-sans text-xs font-semibold tracking-[0.08em] uppercase text-primary-foreground shadow-sm transition-[background-color,transform,box-shadow] hover:bg-primary/90 hover:shadow-md">
              <Link to="/AboutDiscoveryConsultationPage">
                Request Your Discovery Consultation
                <ArrowUpRight className="ml-1.5 size-4 stroke-[1.5]" />
              </Link>
            </Button>
          </div>

          {/* Quiet Trust / Logistics Footnote */}
          <p className="mt-8 text-xs tracking-wider uppercase text-muted-foreground">
            Strictly by appointment &bull; Bespoke family itineraries from $15,000
          </p>
        </motion.div>
      </div>
    </section>;
}